module.exports = __webpack_public_path__ + "img/EU.ea8e3a56.svg";